var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "div-block-25",
    "class": {
      'client-action-handler': _vm.actionButton
    }
  }, [_c('div', {
    staticClass: "add-prijem-btn",
    "class": {
      'client-action-button': _vm.actionButton
    },
    attrs: {
      "data-w-id": "4c06adb2-2b97-ce79-91ef-5e3b3e797c81",
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function click($event) {
        return _vm.openDebtTypePicker();
      },
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter") && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) return null;
        $event.preventDefault();
        return _vm.openDebtTypePicker();
      }
    }
  }, [_c('div', {
    staticClass: "text-small bl-color pointer",
    "class": {
      'client-action-label': _vm.actionButton
    }
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }